import React, { useEffect, useState, useRef, lazy } from 'react';
interface Image {
  url: string;
  alt: string;
}
interface ContinuousImageGalleryProps {
  images: Image[];
  direction?: 'left' | 'right';
  speed?: number;
}
export function ContinuousImageGallery({
  images,
  direction = 'left',
  speed = 0.5
}: ContinuousImageGalleryProps) {
  const sliderRef = useRef<HTMLDivElement>(null);
  const [isReversing, setIsReversing] = useState(false);
  useEffect(() => {
    const slider = sliderRef.current;
    if (!slider) return;
    let animationId: number;
    let position = 0;
    let currentDirection = direction === 'left' ? -1 : 1;
    const pixelsPerFrame = speed;
    const animate = () => {
      position += pixelsPerFrame * currentDirection;
      const imageWidth = 250 + 24; // Reduced width + gap for faster loading
      const totalWidth = imageWidth * images.length;
      // Reverse direction when reaching either end
      if (currentDirection === -1 && Math.abs(position) >= totalWidth) {
        currentDirection = 1;
        setIsReversing(true);
      } else if (currentDirection === 1 && position >= 0) {
        currentDirection = -1;
        setIsReversing(false);
      }
      slider.style.transform = `translateX(${position}px)`;
      animationId = requestAnimationFrame(animate);
    };
    animationId = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(animationId);
  }, [direction, speed, images.length]);
  // Double the images for smoother animation
  const doubledImages = [...images, ...images];
  return <div className="overflow-hidden w-full" data-id="element-97">
      <div ref={sliderRef} className="flex gap-6" style={{
      width: 'fit-content'
    }} data-id="element-98">
        {doubledImages.map((image, index) => <div key={index} className="flex-shrink-0 relative overflow-hidden rounded-2xl shadow-xl group" style={{
        width: '250px',
        height: '350px'
      }} data-id="element-99">
            <img src={image.url} alt={image.alt} loading="lazy" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" style={{
          filter: 'brightness(0.96) contrast(1.08) saturate(0.88) sepia(0.12)'
        }} data-id="element-100" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-101" />
          </div>)}
      </div>
    </div>;
}